import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
import Header from './header';
import Nav from './nav';

const HEADER_HEIGHT = 64;
const NAV_WIDTH = 280;
const NAV_COLLAPSE_WIDTH = 88;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div', {
  shouldForwardProp: (p) => p !== 'navWidth',
})(({ theme, navWidth }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: HEADER_HEIGHT + 24,
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up('lg')]: {
    paddingTop: HEADER_HEIGHT + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const isDesktop = useResponsive('up', 'lg');
  const navWidth = isDesktop ? (isNavCollapsed ? NAV_COLLAPSE_WIDTH : NAV_WIDTH) : NAV_WIDTH;

  return (
    <StyledRoot>
      <Header
        onOpenNav={() => setOpen(true)}
        onToggleNavCollapse={() => setIsNavCollapsed(c => !c)}
        isNavCollapsed={isNavCollapsed}
        navWidth={navWidth}
      />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} isCollapsed={isNavCollapsed} />
      <Main navWidth={navWidth}>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
